import React from 'react';
import { ChatTime } from './chat-time';
import { Message } from './types';
import { MessageText, MessageTextProps } from 'react-native-gifted-chat';
import { StyleSheet, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

export const ChatMessageText: React.FC<MessageTextProps<Message>> = (props) => {
  const hasAttachedFile = props.currentMessage?.image;

  return (
    <View style={styles.container}>
      <MessageText
        currentMessage={props.currentMessage}
        customTextStyle={[TYPOGRAPHY.p, styles.text]}
      />
      <View style={hasAttachedFile ? styles.messageWithImage : null}>
        <ChatTime {...props} />
      </View>
    </View>
  );
};

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  messageWithImage: {
    paddingTop: 8,
  },
  text: {
    // Declare individually to override original styles
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
  },
});
